<div class="notification-container">
    <div *ngIf="userNotifications.length > 0">
        <ng-container *ngFor="let notification of userNotifications">
            <div class="notification" data-testid="user-notification-item">
                <div class="notification-row">

                    <sp-profileimage *ngIf="notification.associatedUserId" class="activity-user-avatar"
                        [userId]="notification.associatedUserId" [fullName]="notification.associatedUserFullName">
                    </sp-profileimage>
                    
                    <!-- "Info" Icon -->
                    <div *ngIf="!notification.associatedUserId" class="info-avatar">
                        <div class="info-icon-wrapper">
                            <i class="fa-solid fa-info"></i>
                        </div>
                    </div>

                    <div class="notification-info-row">

                        <div [innerHtml]="notification.titleTemplate"></div>

                        <div class="notification-datetime-info">

                            <div class="notification-datetime">
                                {{notification.notifyDate + 'Z' | date: 'EEEE, MMMM d, y'}} at
                                {{notification.notifyDate + 'Z' | date: 'h:mm a'}}
                            </div>

                            <div class="notification-timeago">
                                {{notification.notifyDate + 'Z' | timeAgo}}
                            </div>
                        </div>

                        <div *ngIf="notification.bodyTemplate" class="notification-body"
                            [innerHtml]="notification.bodyTemplate">
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>

    <div *ngIf="userNotifications.length === 0" class="no-notifications-message">
        <div class="icon-container">
            <i class="fa-regular fa-bell fa-3x"></i>
        </div>
        <h3 class="margin-top-25">You have no notifications for this property</h3>
    </div>
</div>